import React from 'react';

import FlareStar from 'components/generic/flare/FlareStar.component';
import TimeOffSplashTabs from 'components/hr/timeOffSplash/TimeOffSplashTabs.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './TimeOffSplashTabsContainer.module.scss';

const TimeOffSplashTabsContainer = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TimeOffSplashTabsContainer">
      <div className={CN.sectionTitle} data-bem="TimeOffSplashTabsContainer__sectionTitle">
        <div>{t('humanResources.splashOverview.doLess')}</div>
        <div className={CN.highlight}>
          {t('humanResources.splashOverview.growMore')}
          <FlareStar bottom="35" right="-9" size="22" animation="pulse" variant="dark" />
        </div>
      </div>
      <TimeOffSplashTabs />
    </div>
  );
};

export default TimeOffSplashTabsContainer;
